<div id="donation-card" data-cy="donation-card">
  <h1 *ngIf="!isModalPopup">Donation Card</h1>

  <!-- Improved read-only mode message using PrimeNG flex and p-message -->
  <div *ngIf="isReadOnlyMode" class="p-d-flex p-jc-center p-ai-center p-mb-3" style="width: 100%;">
    <div style="width: 100%; max-width: 700px; font-size: 1.1rem; padding: 0.75rem 1.5rem;">
      <p-message severity="info"
                 text="This page is in read-only mode. Editing is disabled.">
      </p-message>
    </div>
  </div>

  <div class="grid">

    <div class="col-12 xxl:col-8">
      <!-- BEGIN: Donation Tabbed Card -->
      <p-tabView styleClass="tabbed-card" (onChange)="switchTab($event)">

        <div data-cy="donation-header">
          <app-donation-header [donationId]="donationId"
                               [activeTab]="activeTab"
                               [isReadOnlyMode]="isReadOnlyMode"
                               (editDonation)="handleEditDonation()"
                               (donorIdClick)="openDonorCardModal($event)"
                               (deleteDonation)="handleDeleteDonation()"
                               (donationAmountChange)="onDonationAmountChange($event)">
          </app-donation-header>
        </div>

        <p-tabPanel header="General">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-general-tab *ngIf="campaignId"
                                    [donationId]="donationId"
                                    [splitId]="splitId"
                                    [isReadOnlyMode]="isReadOnlyMode"
                                    [campaignId]="campaignId"
                                    (generalInfoUpdated)="handleGeneralInfoUpdate($event)"
                                    (updateDonationHeader)="handleDonationHeaderUpdate($event)">
          </app-donation-general-tab>
        </p-tabPanel>

        <p-tabPanel header="Donor Info">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donor-info-tab [donationId]="donationId"
                              [isReadOnlyMode]="isReadOnlyMode">
          </app-donor-info-tab>
        </p-tabPanel>

        <p-tabPanel header="Contact">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-contact-tab [donationId]="donationId"
                                    [isReadOnlyMode]="isReadOnlyMode">
          </app-donation-contact-tab>
        </p-tabPanel>

        <p-tabPanel header="FEC Compliance">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-fec-compliance-tab *ngIf="campaignId"
                                           (fecInfoRetrieved)="handleFecInfoRetrieved($event)"
                                           [donationId]="donationId"
                                           [isReadOnlyMode]="isReadOnlyMode"
                                           [splitId]="splitId">
          </app-donation-fec-compliance-tab>
        </p-tabPanel>

        <p-tabPanel header="Parent/Child">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-parent-child-tab *ngIf="campaignId"
                                         [donationId]="donationId"
                                         [isReadOnlyMode]="isReadOnlyMode"
                                         [splitId]="splitId"
                                         [campaignId]="campaignId">
          </app-donation-parent-child-tab>
        </p-tabPanel>

        <p-tabPanel header="Fundraisers">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-fundraisers-tab *ngIf="campaignId"
                                        [isReadOnlyMode]="isReadOnlyMode"
                                        [donationId]="donationId"
                                        [campaignId]="campaignId">
          </app-donation-fundraisers-tab>
        </p-tabPanel>

        <p-tabPanel header="Donation Letters">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-letters-tab *ngIf="campaignId"
                                    [isReadOnlyMode]="isReadOnlyMode"
                                    [fecInfo]="fecInfo"
                                    [donationId]="donationId"
                                    [splitId]="splitId"
                                    [campaignId]="campaignId"
                                    [generalInfo]="generalInfo"
                                    (refreshTransactions)="transactionHistoryComponent.loadTransactionHistory()"
                                    (scrollToTransactionHistory)="scrollToTransactionHistory()">
          </app-donation-letters-tab>
        </p-tabPanel>

        <p-tabPanel header="Notes">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donation-notes-tab [donationId]="donationId"
                                  [isReadOnlyMode]="isReadOnlyMode"
                                  [thankYouNoteDialogVisible]="showThankYouNoteDialog"
                                  [customNoteDialogVisible]="showCustomNoteDialog"
                                  (openThankYouDialog)="showThankYouNoteDialog = true"
                                  (openCustomNoteDialog)="showCustomNoteDialog = true">
          </app-donation-notes-tab>
        </p-tabPanel>

        <p-tabPanel header="Donation Flags">
          <hr class="divider-dashed mt-0 mb-5" />
          <app-donation-flags-tab *ngIf="campaignId"
                                  [isReadOnlyMode]="isReadOnlyMode"
                                  [donationId]="donationId"
                                  [campaignId]="campaignId">
          </app-donation-flags-tab>
        </p-tabPanel>
      </p-tabView>
    </div>
    <!-- END: tabbed card -->

    <div class="col-12 md:col-6 xxl:col-4">
      <app-donor-lifetime-history [fundcodesHistory]="fundcodesHistory"></app-donor-lifetime-history>
    </div>

    <div class="col-12 md:col-6 xxl:col-6">
      <app-current-cycle-donations [donationId]="donationId"></app-current-cycle-donations>
    </div>

    <div class="col-12 xxl:col-6">

      <p-card styleClass="card-style-donor">
        <ng-template pTemplate="header">
          <p>Fund Totals</p>
        </ng-template>
        <div class="grid">
          <div class="col-12">
            <app-donor-fund-totals-grid [donationId]="donationId" (fundcodesHistoryLoaded)="onFundcodesHistoryLoaded($event)">
            </app-donor-fund-totals-grid>
          </div>
        </div>
      </p-card>

    </div>

    <div class="col-12">
      <p-card styleClass="card-style-donor">
        <ng-template pTemplate="header">
          <p>Donation Transaction History</p>
        </ng-template>
        <app-donation-transaction-history id="donation-transaction-history"
                                          *ngIf="campaignId"
                                          #transactionHistoryComponent
                                          [donationId]="donationId"
                                          [isReadOnlyMode]="isReadOnlyMode"
                                          [originalDonationAmount]="donationAmount"
                                          [splitId]="splitId"
                                          [campaignId]="campaignId"
                                          (updateDonationGeneralInfo)="handleUpdateDonationGeneralInfo()">
        </app-donation-transaction-history>
      </p-card>
    </div>
  </div>
</div>


<p-toast></p-toast>

<!-- ============================================ -->
<!-- MODALS -->
<!-- ============================================ -->
<!-- Edit Donation MODAL -->
<div id="edit-donation-card" data-cy="edit-donation-card">
  <p-dialog [(visible)]="isDonationEditSidebarVisible"
            header="Edit Donation"
            [modal]="true"
            [maximizable]="true"
            styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

    <div>
      <div ngClass="medium loader-wrapper" *ngIf="isDonorEditDataLoading">
        <rc-loading-spinner></rc-loading-spinner>
      </div>

      <!-- add-donation-add here -->

    </div>

  </p-dialog>
</div>

<!-- Edit Donor/Select Reattribution Donor MODAL -->
<div id="edit-donor-card" data-cy="edit-donor-card">
  <p-dialog [(visible)]="isDonorEditSidebarVisible"
            header="Edit Donor"
            [modal]="true"
            [maximizable]="true"
            styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

    <div>
      <div ngClass="medium loader-wrapper" *ngIf="isDonorEditDataLoading">
        <rc-loading-spinner></rc-loading-spinner>
      </div>

      <app-donor-add [donorToEdit]="donorToEdit"
                     [isEditMode]="true"
                     [activeStep]="editStep"
                     *ngIf="!isDonorEditDataLoading"
                     (closeEditModal)="closeModal()">
      </app-donor-add>
    </div>

  </p-dialog>
</div>

<!-- Donor Card Modal -->
<p-dialog header="Donor Card"
          [modal]="true"
          [(visible)]="isDonorCardModalVisible"
          [maximizable]="true"
          draggable="false"
          styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">
  <app-donor-card [isModalPopup]="true"
                  [isDockable]="true"
                  [fromSearchDonorID]="selectedDonorId"
                  *ngIf="isDonorCardModalVisible">
  </app-donor-card>
</p-dialog>

<!-- Add Delete Confirmation Modal -->
<p-dialog header="Confirm Action"
          [(visible)]="isDeleteModalVisible"
          [modal]="true"
          [closable]="false"
          styleClass="p-confirm-dialog">
  <p>Are you sure you want to delete this donation?</p>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" (onClick)="onCancelDelete()" />
    <p-button label="Delete" (onClick)="onConfirmDelete()" />
  </ng-template>
</p-dialog>



